module.exports = __webpack_public_path__ + "static/media/apple.518b4553.svg";